import {
  getPromotionInfosByPromotionIds,
  getNewCustomerPromotions
} from '@/models/api/promotionApi.js';
import { getCustomerActualPurchase } from '@/models/api/orderConfirmApi';
import constants, { encryptedMarketplaceId } from '@/constants';
import { isLoginAuthenticated } from '@/utils/common';

async function getNCPromotions() {
  let couponList = [];
  const { data: PromotionsData } = await getNewCustomerPromotions({
    encryptedMarketplaceId
  });
  if (
    !PromotionsData ||
    !PromotionsData?.promotions ||
    !PromotionsData?.promotions?.length
  ) {
    return couponList;
  }
  const promotionsIds = [];
  PromotionsData?.promotions?.forEach(item => {
    if (
      item.status === constants.COUPON_SERVICE_PROMOTION_STATUS.ACTIVE ||
      item.status === constants.COUPON_SERVICE_PROMOTION_STATUS.REDEEMED
    ) {
      promotionsIds.push(item.promotionId);
    }
  });
  if (!promotionsIds.length) return couponList;
  const { data: promotionInfo } = await getPromotionInfosByPromotionIds(
    promotionsIds
  );
  couponList = promotionInfo?.miniAppPromotionList?.map(item => ({
    id: item.encryptedPromotionId,
    text: item.optimizedShortMerchandisingMessage,
    threshold: item.thresholds[0]?.currencyAmount?.amount,
    amount: item.benefits[0]?.fixedAmount?.amount
  }));
  return couponList;
}
export async function getNewCustomerCoupon() {
  if (await isLoginAuthenticated(false)) {
    try {
      const { data } = await getCustomerActualPurchase();
      if (data.hasActualPurchase === false) {
        return {
          promotionList: await getNCPromotions()
        };
      }
      return { promotionList: [] };
    } catch (error) {
      console.error(error, 'api---getCustomerActualPurchase---error');
      return { promotionList: [] };
    }
  } else {
    return {
      promotionList: await getNCPromotions()
    };
  }
}
